import React, { useState } from "react";
import BasicModal from "components/BasicModal";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import JsonTable from "../../../../components/JsonTable/JsonTable";
import { useGetByVendorInvoiceFileIdQuery } from "../../vendorInvoiceFile/vendorInvoiceFileSlice";
import { Button } from "@material-ui/core";

const OutputInvoicePreview = ({ vendorInvoiceFileId }) => {

  const [open, setOpen] = useState(false);
  const shouldFetch = !!vendorInvoiceFileId && open;
  const { data, isLoading } = useGetByVendorInvoiceFileIdQuery(vendorInvoiceFileId, { skip: !shouldFetch });
  let outputData = data?.output;
  let validJson = true;
  
  if (!isLoading && outputData && typeof outputData === "string") {
    try {
      outputData = JSON.parse(outputData);
    } catch (error) {
      validJson = false;
    }
  }

  const content = isLoading ? <LoadingSpinner loading /> : <>
    {(validJson && typeof outputData === "object") ? (
      <JsonTable data={outputData} />
    ) : validJson && outputData ? (
      <div>{outputData}</div>
    ) : (
      <div>No data to display</div>
    )}
  </>;

  return (
    <>
      <Button aria-label="View Details" onClick={() => setOpen(true)} color="primary">
        View Details
      </Button>
      <BasicModal open={open} wide handleClose={() => setOpen(false)} header="LLM Output Details" component={content} />
    </>
  );
};

export default OutputInvoicePreview;
